import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { ClickAwayListener, Drawer as MuiDrawer, styled } from "@mui/material";
import React from "react";
import { Button } from "../Button/Button";
import AderantTheme from "../Theme/AderantTheme";
import { Messages } from "./Messages";
const classes = {
    paperRoot: "flyout-root",
    closeButtonContainer: "flyout-closeButtonContainer",
    closeButton: "flyout-closeButton"
};
const StyledMuiDrawer = styled(MuiDrawer)(({ theme, closeButton, variant, anchor }) => ({
    [`& .${classes.paperRoot}`]: {
        backgroundColor: closeButton && variant === "persistent" ? "transparent" : theme.palette.background.white,
        borderLeft: anchor == "right" ? ((closeButton && variant === "persistent") || variant == "temporary" ? "none" : `1px solid ${theme.palette.border.main}`) : "none",
        borderRight: anchor == "left" ? ((closeButton && variant === "persistent") || variant == "temporary" ? "none" : `1px solid ${theme.palette.border.main}`) : "none",
        flexDirection: anchor == "left" ? "row-reverse" : "row"
    },
    [`& .${classes.closeButtonContainer}`]: {
        backgroundColor: "transparent",
        borderRight: anchor == "right" ? `1px solid ${theme.palette.border.main}` : "none",
        borderLeft: anchor == "left" ? `1px solid ${theme.palette.border.main}` : "none"
    },
    [`& .${classes.closeButton}`]: {
        "&:hover": {
            borderRadius: anchor == "right" ? "50% 0 0 50%" : "0 50% 50% 0"
        }
    }
}));
export const Flyout = ({ closeButton, variant, anchor, open, onClose, children, onClickAway, sx = [] }) => {
    const handleClickAway = (event) => {
        if (onClickAway) {
            onClickAway(event);
        }
    };
    return (React.createElement(ClickAwayListener, { onClickAway: handleClickAway },
        React.createElement(StyledMuiDrawer, { sx: sx, anchor: anchor, open: open, variant: variant, onClose: onClose, classes: { paper: classes.paperRoot }, closeButton: closeButton, PaperProps: { "data-testid": "flyout" } },
            closeButton && variant === "persistent" && (React.createElement("div", { className: classes.closeButtonContainer },
                React.createElement(Button, { iconButton: true, startIcon: (anchor == "right" && React.createElement(ChevronRightIcon, null)) || (anchor == "left" && React.createElement(ChevronLeftIcon, null)), onClick: () => onClose && onClose(), "aria-label": Messages.CLOSE_FLYOUT.getMessage(), rounded: true, variant: "plain", color: "primary", style: {
                        backgroundColor: AderantTheme.palette.background.white,
                        border: `1px solid ${AderantTheme.palette.border.main}`,
                        borderRight: anchor == "right" ? "none" : `1px solid ${AderantTheme.palette.border.main}`,
                        borderLeft: anchor == "left" ? "none" : `1px solid ${AderantTheme.palette.border.main}`,
                        marginRight: anchor == "right" ? "-1px" : "1px",
                        marginLeft: anchor == "left" ? "-1px" : "1px",
                        borderRadius: anchor == "right" ? "50% 0 0 50%" : "0 50% 50% 0",
                        marginTop: "10px"
                    }, className: classes.closeButton }))),
            children)));
};
//Prop defaults
Flyout.defaultProps = {
    variant: "persistent",
    anchor: "right",
    closeButton: false
};
